import API                          from '../../../common/http/api.fetch';
import {success, responseMessage}   from '../../../common/utils/util.notifier';
import I18N                         from '../../../common/utils/util.i18n';
import {GRID_FETCH, GRID_RELOAD} from '../../../common/grid/grid.constants';
import {TYPES} from './add-document-action-type.constants';
import {IDS} from './add-document-action-id.constants';
import {formatDate} from "../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../common/utils/util.constants";
// import {getDocFileNameFromPath} from "../../../common/utils/util.path";

export const fetchSiteLocationDetails = (siteLocationUuid) => {
    return dispatch => {
        return API.fetch({
            url: `/location/sitelocation/${siteLocationUuid}`,
            method: 'GET',
            params: {}
        }).then(response => {
            const siteLocation = response.data[0][0];
            dispatch({
                type: TYPES.FETCH_SITE_LOCATION_DETAILS,
                id: IDS.accAddDocument,
                data: {
                    siteLocationUuid,
                    siteLocationName: siteLocation.name,
                    // fiscalYearStart: parseInt(  siteLocation.fiscal_year_start ) - 1,
                    // sloQualityManagers: response.data[1].map(item => ({...item, employee_uuid: item.subject_uuid})),
                }
            })
        })
    }
}

export const getFrameworkRequirementDetails = (id) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/framework-requirement-details',
            method: 'GET',
            params: {id}
        }).then(response => {
            const { section_name, description, status_name, status_code, scheme_name } = response.data.details
            dispatch({
                type:   TYPES.FETCH_SECTION_DETAILS,
                id: IDS.accAddDocument,
                data:   {
                    sectionId:             id,
                    sectionName:           section_name,
                    sectionDescription:    description,
                    sectionStatusName:     status_name,
                    sectionStatusCode:     status_code,
                    schemeName:             scheme_name,
                }
            })
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchLocAssignableVersionedDocumentsGrid = (params) => {
    return dispatch => {
        if(!params.siteLocationUuid || !params.sectionId)
            return;
        return API.fetch({
            url: '/accreditation/list-loc-assignable-version-documents',
            method: 'GET',
            params,
        }).then(({data}) => {
            return dispatch({
                type: GRID_FETCH,
                id: IDS.accAddDocument,
                path: IDS.addFromExistingGrid,
                ...data,
                items: data.items.map(item => ({
                    ...item,
                    id: item.vdo_uuid,
                    filename: item.doc_url.split('/').pop(),
                }))
            });
        }, error => {
            responseMessage(error);
        })
    }
}

// export const assignVersionedDocToSection = (vdo_uuid, ase_id, slo_uuid) => {
//     return dispatch => {
//         return API.fetch({
//             url: '/accreditation/assign-versioned-doc-to-section',
//             method: 'POST',
//             data: {
//                 vdo_uuid,
//                 ase_id,
//                 slo_uuid,
//             }
//         }).then(response => {
//             success('COMMON.SERVER_RESPONSE.ITEM_ASSIGNED');
//             dispatch({
//                 type: GRID_RELOAD,
//                 id: IDS.accAddDocument,
//                 path: IDS.addFromDisabledGrid
//             });
//         },error => {
//             responseMessage(error)
//         });
//     };
// };

export const addEvidenceGroup = (loc_uuid, doc_num, name, description, document_type, ase_id, doc_date, due_date, path = null) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/add-evidence-group',
            method: 'POST',
            data: {
                loc_uuid,
                doc_num,
                name,
                description,
                document_type,
                ase_id,
                doc_date: formatDate(doc_date, DATE_FORMAT.OUTPUT),
                due_date: formatDate(due_date, DATE_FORMAT.OUTPUT),
                path,
            }
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_ADDED');
            return response
        },error => {
            responseMessage(error)
        });
    };

}
